import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import uploadImagetow from '@/components/uploadImagetow';
import addEmperor from "./components/addServer.vue";
import unsealServer from "./components/unsealServer.vue";
import { banUserList } from "@/api/gmToolNew/gmToolNew";
import { gmToolNew, gmToolNewPage } from "@/mixins/index";
export default {
  name: "banUserList",
  mixins: [gmToolNew, gmToolNewPage],
  components: {
    addEmperor: addEmperor,
    unsealServer: unsealServer,
    uploadImagetow: uploadImagetow
  },
  data: function data() {
    return {
      advanced: false,
      currentPage: 1,
      tableData: [],
      paramsData: {
        uids: '',
        start_time: '',
        end_time: '',
        page: 1
      },
      date: [],
      total: 0,
      popData: {
        server_id: ''
      }
    };
  },
  created: function created() {},
  activated: function activated() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    getList: function getList(e) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this.paramsData.server_id.length == 0)) {
                  _context2.next = 3;
                  break;
                }

                _this.$message.error(_this.$t('pleaseSelectServer'));

                return _context2.abrupt("return");

              case 3:
                _this.paramsData.page = e;
                _this.paramsData.start_time = _this.date && _this.date[0] ? _this.$times.timestampToTime(_this.date[0] / 1000, "YY-MM-DD hh:mm:ss") : '';
                _this.paramsData.end_time = _this.date && _this.date[1] ? _this.$times.timestampToTime(_this.date[1] / 1000, "YY-MM-DD hh:mm:ss") : '';
                _this.reqLoading = true;
                banUserList(_this.paramsData).then(function (res) {
                  if (res.code == 200) {
                    _this.tableData = res.data.result;
                    _this.total = res.data.count;
                  }
                }).finally(function () {
                  _this.reqLoading = false;
                });

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    banAddClick: function banAddClick() {
      if (this.paramsData.server_id.length == 0) {
        this.$message.error(this.$t('pleaseSelectServer'));
        return;
      }

      this.$refs.addEmperor.open({}, false);
    },
    unsealClick: function unsealClick() {
      if (this.paramsData.server_id.length == 0) {
        this.$message.error(this.$t('pleaseSelectServer'));
        return;
      }

      this.$refs.unsealServer.open();
    }
  }
};